import React, { useEffect } from "react";
import gameImg from '../../Img/game_img.jpg'
import { MdDoubleArrow } from "react-icons/md";
import { Link } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaRocket } from "react-icons/fa";

const AboutHeroSection = () => {

 useEffect(() => {
  import("aos").then((AOS) => {
    AOS.default.init({
      duration: 500,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });
  });
}, []);

  return (
    <section 
      className="relative lg:px-8 text-white sm:py-16 py-10 overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-800"
    >
      <div className="container mx-auto px-4">
        
        <div className="flex md:flex-nowrap flex-wrap flex-row-reverse items-center gap-10 lg:gap-16">
          
          <div 
            className="lg:w-3/5 md:w-1/2 w-full"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <div className="md:ps-6 lg:ps-10">
              <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold leading-tight flex flex-wrap items-center gap-3 mb-6" data-aos="zoom-in" data-aos-delay="400">
                Our Mission &{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
                  Story
                </span>
                <FaRocket className="text-cyan-400 hover:-translate-y-1 transition-transform duration-300" />
              </h2>

              {/* 🚀 EXPANDED CONTENT FOR LOW CONTENT QUALITY FIX */}
              <div className="space-y-5 text-gray-300 sm:text-lg text-[16px] leading-relaxed font-light mb-8">
                <p data-aos="fade-up" data-aos-delay="500">
                  Game Zone Hub started with a simple, yet incredibly powerful idea: <strong>premium digital gaming should be universally accessible to absolutely everyone</strong>. We noticed that finding high-quality, safe, and truly free browser games was becoming increasingly difficult due to intrusive paywalls, annoying pop-up ads, and frustratingly slow loading times that ruined the user experience.
                </p>
                <p data-aos="fade-up" data-aos-delay="600">
                  We set out to permanently change that landscape. Today, we provide a seamless, cross-platform entertainment hub. By harnessing the power of modern <strong>HTML5 and WebGL technology</strong>, we ensure that whether you are commuting with a smartphone, relaxing with a tablet, or sitting at a high-end desktop PC, you can <strong>play free online games</strong> instantly. You never need to download a single file, install heavy applications, or risk your device's security.
                </p>
              </div>

              {/* 🚀 EXPANDED CHECKMARKS WITH DESCRIPTIONS FOR MORE TEXT VALUE */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10" data-aos="fade-up" data-aos-delay="700">
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-green-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">100% Virus Free</span>
                        <span className="text-sm text-gray-400 leading-snug">Every game runs in a secure sandbox, guaranteeing a malware-free experience.</span>
                      </div>
                  </div>
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-cyan-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">Instant Online Play</span>
                        <span className="text-sm text-gray-400 leading-snug">Zero wait times. Click any title and jump straight into the action without downloading.</span>
                      </div>
                  </div>
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-purple-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">Mobile Optimized</span>
                        <span className="text-sm text-gray-400 leading-snug">Fully responsive designs featuring intuitive touch-swipe controls for iOS & Android.</span>
                      </div>
                  </div>
                  <div className="flex flex-wrap items-start gap-3 text-gray-200 bg-white/5 p-4 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                      <IoCheckmarkCircle className="text-yellow-500 mt-1 shrink-0" size={24} /> 
                      <div>
                        <span className="font-bold text-white block mb-1">Daily New Games</span>
                        <span className="text-sm text-gray-400 leading-snug">Our catalog expands daily with fresh, high-quality content across all genres.</span>
                      </div>
                  </div>
              </div>
   
              <div 
                className="flex flex-row gap-4 md:justify-start"
                data-aos="fade-up"
                data-aos-delay="800"
              >
                <Link 
                  to="/games"
                  aria-label="Explore and play our massive library of free online games"
                  className="px-8 sm:py-4 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-full font-bold text-lg flex items-center gap-3 hover:from-blue-500 hover:to-cyan-400 transition-all duration-300 shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] transform hover:scale-105"
                >
                  Explore Free Games <MdDoubleArrow size={22} />
                </Link>
              </div>
            </div>
          </div>

          <div 
            className="relative lg:w-2/5 md:w-1/2 w-full md:mt-0 sm:mt-10"
            data-aos="zoom-in-up"
            data-aos-delay="500"
          >
            <div className="rounded-3xl overflow-hidden shadow-[0_10px_35px_rgba(0,150,255,0.25)] border border-white/10 hover:shadow-[0_20px_45px_rgba(0,150,255,0.45)] transition-all duration-500 hover:scale-[1.03] group">
              <picture>
               <source
                  srcSet={gameImg}
                  type="image/jpg"
                />
                <img
                src={gameImg}
                alt="Game Zone Hub Mission - Providing the best free online HTML5 browser games instantly"
                title="Game Zone Hub Mission"
                className="object-cover w-full h-full cursor-pointer transition-transform duration-700 group-hover:scale-110"
                fetchpriority="high"
                decoding="async"
                />
              </picture>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
            </div>

            <div className="absolute -z-10 top-10 -left-10 w-80 h-80 bg-blue-600 rounded-full mix-blend-screen filter blur-[80px] opacity-30 animate-pulse"></div>
            <div className="absolute -z-10 bottom-10 -right-10 w-80 h-80 bg-purple-600 rounded-full mix-blend-screen filter blur-[80px] opacity-30 animate-pulse" style={{animationDelay: '1s'}}></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutHeroSection;